<template>
    <b-card-code>
      <b-row class="match-height" style="margin-top: -30px">
            <b-col cols="2">   
              <div class="demo-inline-spacing" style="margin-bottom: 10px">
                  <b-form-radio
                      v-model="propiedadGraficaSelect"
                      name="some-radios"
                      value="Cantidad"
                      >
                      Cantidad
                      </b-form-radio>
                      <b-form-radio
                      v-model="propiedadGraficaSelect"
                      name="some-radios"
                      value="Dinero"
                      >
                      Dinero
                  </b-form-radio>
                </div>
            </b-col>
            <b-col cols="2">
                <flat-pickr
                  v-model="rangeDate"
                  class="form-control"
                  :config="{ mode: 'range'}"
                  style="    margin-top: 13px;"
                />
            </b-col>
            <b-col cols="3">              
                <div class="demo-inline-spacing">
                   <b-form-checkbox
                    v-model="ventasCheck"
                  >
                    Ventas
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="visitasCheck"
                  >
                    Visitas
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="stockCheck"
                  >
                    Stock
                  </b-form-checkbox>
                </div>
            </b-col>
      </b-row>
        <b-row class="match-height">
            <b-col cols="12">                   
                <apexchart ref="marketingGrafica" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
            </b-col>
        </b-row>
        <b-row v-if="false">
          <b-col cols="11">
            <vue-slider
                v-model="sliderFecha"
                direction="rtl"
                class="mb-2"
                :data="dayListParseSlider"
                :marks="true"
                :process="false"

              />
          </b-col>
          <b-col cols="1" style="margin-top: -10px">
            <b-button
                variant="success"
                class="btn-icon rounded-circle"
                style="margin-right: 10px"
                @click="moreSlider()"
              >
                <i class="fa-solid fa-plus"></i>
            </b-button>

            <b-button
                variant="danger"
                class="btn-icon rounded-circle"
                @click="lessSlider()"
              >
                <i class="fa-solid fa-minus"></i>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="match-height">
          <b-col cols="12">
            <b-button style="width: 120px; position: absolute; right: 20px;" size="sm" class="mr-1" variant="secondary" @click="deseleccionarSeries()" >
              Ocultar sku
            </b-button>
            <b-button style="margin-bottom: 10px; margin-top: 20px; width: 120px" size="sm" class="mr-1" variant="primary" @click="verTabla = !verTabla" >
              <span v-if="!verTabla">Ver Tabla</span>
              <span v-else>Ocultar tabla</span>
            </b-button>
          </b-col>

        </b-row>
        <b-row class="match-height" v-if="verTabla">
          <div class="demo-inline-spacing" style="margin-bottom: 10px; margin-left: 10px">
            <b-form-radio
                v-model="propiedadTablaSelect"
                name="tabla-prop"
                value="Stock"
                >
                Stock
            </b-form-radio>
            <b-form-radio
                v-model="propiedadTablaSelect"
                name="tabla-prop"
                value="Ventas"
                >
                Ventas
            </b-form-radio>
          </div>
          
          <b-col cols="12">
            <b-table
              :items="linesTable"
              :fields="columnasTable"
              class="table table-borderless"
              no-border-collapse
              sort-icon-left
              :fixed="true"
              responsive="md"
            >
            </b-table>
          </b-col>
        </b-row>
    </b-card-code>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable , BFormCheckbox, BFormInput, BFormGroup, BModal, BCardText, BCardBody, BCard, BRow, BCol, BSpinner, BButton, BFormRadio} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import flatPickr from 'vue-flatpickr-component'
import VueSlider from 'vue-slider-component'


  export default {
    components: {
        BCardCode,
        BFormCheckbox,
        BTable,
        BFormInput,
        BFormGroup,
        BCardText,
        BCardBody,
        BCard,
        BRow,
        BCol,
        BSpinner,
        BButton,
        BFormRadio,
        flatPickr,
        VueSlider
    },
    data () {
      return {
        coloresGrafica: ["#E322B5","#1FFF00","#eb6170","#2586ed","#8772d1","#e0914c","#6399c1","#f9fa66","#e0684c","#146799","#ecbd49","#eb6170","#2586ed","#8772d1","#e0914c","#6399c1","#f9fa66","#e0684c","#146799","#ecbd49","#eb6170","#2586ed","#8772d1","#e0914c","#6399c1","#f9fa66","#e0684c","#146799","#ecbd49","#eb6170","#2586ed","#8772d1","#e0914c","#6399c1","#f9fa66","#e0684c","#146799","#ecbd49"],
        //rangeDate: "2022-12-01 to 2022-12-31",
        rangeDate: "",
        visitasCheck: true,
        stockCheck: true,
        ventasCheck: true,
        widthLineVenta: 3,
        widthLineVisitas: 1,
        series: [],
        columnasTable: [],
        linesTable: [],
        sliderFecha: [],
        chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            title: {
              text: '',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            },
            animations:{
              enabled: false,
            }
          },
        articulos: [],
        propiedadGraficaSelect: "Cantidad",
        propiedadTablaSelect: "Ventas",
        dayListArray: [],
        dayListParseSlider: [],
        verTabla: false,
        variantesStockSeleccionado: [],
        ventasSkuSeleccionado: [],
        dayListSeleccionado: []
      }      
    },
    props: [
        "items",
        "anyo",
        "urls"
      ],
    methods:{
      calcularDatos(){
         let auxSeries = [];

         this.articulos.forEach(articulo => {

            articulo.variantes.forEach(variante => {

                variante.cantidades.forEach(item => {

                    let serie = auxSeries.filter(function (el) {
                        return el.shopify_product_id == articulo.shopify_product_id;
                    });

                    if(serie.length > 0)
                    {
                        if(item.anyo == this.anyo)
                        {
                            if(this.propiedadGraficaSelect == "Dinero")
                                serie[0].data[item.mes-1] += Math.round(item.total);
                            else
                                serie[0].data[item.mes-1] += Math.round(item.cantidad);
                        }
                    }
                    else
                    {

                        let newYear = {
                        name: articulo.title.slice(0,20),
                        data: [0,0,0,0,0,0,0,0,0,0,0,0],
                        shopify_product_id: articulo.shopify_product_id
                        };

                        if(this.propiedadGraficaSelect == "Dinero")
                            newYear.data[item.mes-1] = Math.round(item.total);
                        else
                            newYear.data[item.mes-1] = Math.round(item.cantidad);

                        auxSeries.push(newYear);
                    }

                });
                
            });
        });
          this.series = [];

          let auxChart =  {
                        chart: {
                          height: 350,
                          type: 'line',
                          zoom: {
                            enabled: false
                          },
                          toolbar: {
                            show: false,
                          }
                        },
                        dataLabels: {
                          enabled: false
                        },
                        stroke: {
                          curve: 'straight'
                        },
                        title: {
                          text: '',
                          align: 'left'
                        },
                        grid: {
                          row: {
                            colors: ['transparent', 'transparent'],
                            opacity: 0.5
                          },
                        },
                        xaxis: {
                          categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                        },
                        colors: this.coloresGrafica
                      };

          //console.log(auxSeries);
          setTimeout(()=>{
            this.chartOptions = auxChart;
            this.series = auxSeries;
          }, 100);
      
      },
      getDatosFecha(){

        /*let info = { fechaInicio: this.rangeDate.split(" to ")[0],
                     fechaFin: this.rangeDate.split(" to ")[1]}*/

        let info = { fechaInicio: new Date(this.rangeDate.split(" to ")[0]),
                     fechaFin: new Date(this.rangeDate.split(" to ")[1])}
          
        if(info.fechaFin != undefined && this.articulos.length > 0)
        {

           var getDaysArray = function(start, end) {
              for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){
                  arr.push(new Date(dt).toISOString().slice(0,10));
              }
              return arr;
          };

          var daylist = getDaysArray(new Date(info.fechaInicio),new Date(info.fechaFin));

          info.fechaInicio = new Date(info.fechaInicio.setDate(1));

          info.fechaFin.setDate(info.fechaFin.getDate() + 1);

          let ventasCargadas = false;
          let visitasCargadas = false;
          let stockCargado = false;
          let stockMensualCargado = false;

          let ventas = [];
          let visitas = [];
          let stocks = [];
          let stockMensual = [];

          let allSku = [];
          this.articulos.forEach(articulo => {
            articulo.variantes.forEach(variante => {
              allSku.push(variante.sku)
            });
          });

          info.sku = allSku;
          //info.sku = ["DESK-MAT-XL-BLK"];

          if(this.ventasCheck)
          {
            axios
              .post("/ventas/diaria/fecha", info)
              .then(response => {
                  return response.data;
              })
              .then(resVentas => {

                  ventas = resVentas;

                  ventas.forEach(venta => {

                    let auxDate = new Date(venta.fecha);
                    auxDate.setDate(auxDate.getDate() + 1);
                    venta.fecha = auxDate.toISOString();
                    
                  });

                  //console.log(ventas);
                  ventasCargadas = true;
              });
          }
          else
            ventasCargadas = true;

          if(this.visitasCheck)
          {
            axios
              .post("/visitas/diaria/fecha", info)
              .then(response => {
                  return response.data;
              })
              .then(resVisitas => {

                visitas = resVisitas;    
                visitas.forEach(visita => {
                    let auxDate = new Date(visita.fecha);
                    auxDate.setDate(auxDate.getDate() + 1);
                    visita.fecha = auxDate.toISOString();
                  });
                visitasCargadas = true;
              });
          }
          else
            visitasCargadas = true;

          if(this.stockCheck)
          {
            

            axios
              .post("/articulos/sku/stock", {sku: allSku, fechaInicio: info.fechaInicio, fechaFin: info.fechaFin})
              .then(response => {
                  return response.data;
              })
              .then(resStock => {
                //console.log(resStock);
                stocks = resStock;
                stockCargado = true;
              });

            //el stock mensual se guarda al final del mes, por eso resto 1 mes (Enero-31 se guarda el stock, pero en la bd sale como Enero)
            let fechaInicioMesAnterior = new Date(info.fechaInicio);
            fechaInicioMesAnterior = new Date(fechaInicioMesAnterior.setMonth(fechaInicioMesAnterior.getMonth()-1));
            let fechaFinMesAnterior = new Date(info.fechaFin);
            fechaFinMesAnterior = new Date(fechaFinMesAnterior.setMonth(fechaFinMesAnterior.getMonth()-1));

            axios
              .post("/articulos/sku/stock/mensual", {sku: allSku, fechaInicio: fechaInicioMesAnterior, fechaFin: fechaFinMesAnterior})
              .then(response => {
                  return response.data;
              })
              .then(resStock => {
                //console.log(resStock);
                stockMensual = resStock;
                stockMensualCargado = true;
              });

          }
          else
          {
            stockCargado = true;
            stockMensualCargado = true;
          }

          let esperandoGets = setInterval(() => {
            if (ventasCargadas && visitasCargadas && stockCargado && stockMensualCargado) {
              clearInterval(esperandoGets);
              //Empiezan los calculos

              let auxSeries = [];
              let auxStock = [];
              let auxVarianteStock = [];
              let auxVentasSku = [];

              this.articulos.forEach(articulo => {

                let allDays = [];
                let allDaysVisits = [];
                let allDaysStock = [];
                let allCantidadNeto = [];                

                daylist.forEach(day => {
                  allDays.push(0);
                  allDaysVisits.push(0);
                  allDaysStock.push(0);
                  allCantidadNeto.push(0);
                });

                //VENTAS
                let newAticuloLine = {
                    name: "Ventas: " + articulo.title.slice(0,20),
                    data: allDays,
                    shopify_product_id: articulo.shopify_product_id
                    };

                  articulo.variantes.forEach(variante => {

                    let allCantidadNetoVariante = [];
                    daylist.forEach(day => {
                      allCantidadNetoVariante.push(0);
                    });

                    ventas.forEach(ventaDiaria => {

                      if(ventaDiaria.sku == variante.sku)
                      {
                        let index = daylist.findIndex(dato => dato == ventaDiaria.fecha.slice(0,10));

                        if(index  >= 0)
                        {
                          if(this.propiedadGraficaSelect == "Dinero")
                            newAticuloLine.data[index] +=  Math.round(ventaDiaria.total_ventas);
                          else
                            newAticuloLine.data[index] +=  Math.round(ventaDiaria.cantidad);

                          allCantidadNeto[index] += ventaDiaria.cantidad_neto;
                          allCantidadNetoVariante[index] += ventaDiaria.cantidad_neto;
                        }

                      }
                      
                    })

                    let newStockSku = {
                      data: allCantidadNetoVariante,
                      sku: variante.sku,
                      shopify_product_id: articulo.shopify_product_id
                    };

                    auxVarianteStock.push(newStockSku);

                  });
                  //FIN VENTAS

                  auxVentasSku = JSON.parse(JSON.stringify(auxVarianteStock));

                  //VISITAS
                  let newVisitLine = {
                    name: 'Visitas: ' + articulo.title.slice(0,20),
                    type: 'area',
                    data: allDaysVisits,
                    shopify_product_id: articulo.shopify_product_id
                    };

                  visitas.forEach(visita => {
                    let index = daylist.findIndex(dato => dato == visita.fecha.slice(0,10));

                    if(index >= 0 && articulo.handle == visita.path)
                    {
                      newVisitLine.data[index] += visita.visitors;
                    }

                  });
                  //FIN VISITAS

                  //STOCK
                  let newStockSerie = {
                    name: "Stock: " + articulo.title.slice(0,20),
                    type: 'column',
                    data: allDaysStock,
                    shopify_product_id: articulo.shopify_product_id
                    };

                  //buscar la primera cifra de cada sku
                  let inicioStockArticulo = 0;
                  let inicioStockSku = [];

                  articulo.variantes.forEach(variante => {

                    let inicioSku = 0;

                    let skuIntroducido = false
                    stockMensual.forEach(stock => {
                      if(variante.sku == stock.sku && !skuIntroducido)
                      {
                        inicioSku = stock.cantidad;
                        inicioStockArticulo += stock.cantidad;
                        skuIntroducido = true;
                      }
                      
                    });

                    inicioStockSku.push({sku: variante.sku, inicio: inicioSku })

                  });

                  //Aqui lo que hago es restar las ventas anteriores a esa fecha hasta el punto que conozco el stock
                  //tambien sumo el incremento de stock de los días anteriores hasta que conozco el stock
                  //FUMADON
                  let fechaStart = new Date(daylist[0]);

                  articulo.variantes.forEach(variante => {
                    
                    let stopCount = false;
                    
                    ventas.forEach(ventaDiaria => {

                      if(ventaDiaria.sku == variante.sku)
                      {

                        if( new Date(ventaDiaria.fecha.slice(0,10)) >= fechaStart )
                          stopCount = true;

                        if( !stopCount)
                        {
                          let index = inicioStockSku.findIndex(dato => dato.sku == variante.sku);

                          if(index >= 0)
                          {
                            inicioStockSku[index].inicio -= ventaDiaria.cantidad_neto;
                          }

                          inicioStockArticulo -= ventaDiaria.cantidad_neto;
                        }
                      }

                    });

                    stocks.forEach(stock => {

                      if(stock.sku == variante.sku)
                      {
                        if( new Date(stock.fecha.slice(0,10)) < fechaStart )
                        {
                            inicioStockArticulo += stock.increase;

                            let index = inicioStockSku.findIndex(dato => dato.sku == variante.sku);

                            if(index >= 0)
                              inicioStockSku[index].inicio += stock.increase;
                        }
                      }
                      
                    });

                  });
                  //FIN FUMADON                

                  //sumar el stock añadido al dia especifico
                  articulo.variantes.forEach(variante => {

                    stocks.forEach(stock => {
                      
                      let index = daylist.findIndex(dato => dato == stock.fecha.slice(0,10));

                      if(index >= 0 && variante.sku == stock.sku)
                      {                
                        allCantidadNeto[index] -= stock.increase;

                        let indexSku = auxVarianteStock.findIndex(dato => dato.sku == variante.sku);

                        if(indexSku >= 0)
                          auxVarianteStock[indexSku].data[index] -= stock.increase;
                      }

                    });
                  });

                  //ir restando las ventas

                  /*for (let index = 0; index < newStockSerie.data.length; index++) {
                    inicioStockArticulo -= allCantidadNeto[index];
                    newStockSerie.data[index] = inicioStockArticulo;
                  }*/                  

                  inicioStockSku.forEach(skuStock => {

                    let indexSku = auxVarianteStock.findIndex(dato => dato.sku == skuStock.sku);

                      if(indexSku >= 0)
                      {
                        let auxStockInicio = skuStock.inicio;
                        for (let index = 0; index < auxVarianteStock[indexSku].data.length; index++) {
                            auxStockInicio -= auxVarianteStock[indexSku].data[index];
                            auxVarianteStock[indexSku].data[index] = auxStockInicio;
                          }
                      }
                  });

                  /*console.log(inicioStockSku);
                  console.log(auxVarianteStock); //este es el bueno, con esto tengo que sacar las anotaciones https://apexcharts.com/vue-chart-demos/line-charts/line-chart-annotations/
                  console.log(newStockSerie);*/

                  //FIN STOCK

                  if(this.ventasCheck)
                    auxSeries.push(newAticuloLine);

                  if(this.visitasCheck)
                  {                    
                    if(this.ventasCheck)
                      for (let index = 0; index < newVisitLine.data.length; index++) {
                        newVisitLine.data[index] = Math.round(newVisitLine.data[index]/10);
                      }

                    auxSeries.push(newVisitLine);
                  }

                  if(this.stockCheck)
                  {
                    //auxSeries.push(newStockSerie);
                    auxStock.push(newStockSerie);

                    auxVarianteStock.sort((a,b) => b.data[0] - a.data[0]);

                    auxVarianteStock.forEach(varianteStock => {

                      auxSeries.push({
                        name: "Stock: " + varianteStock.sku,
                        type: 'column',
                        data: varianteStock.data
                        });

                    });

                  }

              });

              let daylistParse = [];

              daylist.forEach(data => {
                daylistParse.push(data.split('-')[2]+"-"+data.split('-')[1]);                
              });

              this.dayListParseSlider = JSON.parse(JSON.stringify(daylistParse));;
              this.dayListParseSlider.reverse();

              this.series = [];

              let auxVentasCheck = this.ventasCheck;

              let widthLinesChart = [];
              for (let index = 0; index < auxSeries.length; index+=2) {
                if(this.ventasCheck)
                  widthLinesChart.push(this.widthLineVenta)
                if(this.visitasCheck)
                  widthLinesChart.push(this.widthLineVisitas)
              }

              widthLinesChart = [];

              function pruebaFuncion(serie, point) {
                //return auxStock[0].data[point];
                return "";
                if(auxStock[0].data[point] <= 0)
                  return "-";
                else
                  return "";
              }
              
              let auxAnotations = {xaxis: this.getAnotationsGrafica(auxVarianteStock, daylist)};
              let minYaxis = 0;

              if(this.stockCheck)
                minYaxis = -10;

              auxAnotations = [];

               let auxChart =  {
                      chart: {
                        height: 350,
                        type: 'bar',
                        stacked: true,
                        zoom: {
                          enabled: false
                        },
                        toolbar: {
                          show: false,
                        }
                      },
                      dataLabels: {
                        enabled: false
                      },
                      stroke: {
                        curve: 'straight',
                        width: [2,2],
                      },
                      title: {
                        text: '',
                        align: 'left'
                      },
                      grid: {
                        row: {
                          colors: ['transparent', 'transparent'],
                          opacity: 0.5
                        },
                      },
                      dataLabels: {
                        enabled: true,
                        enabledOnSeries: [0],
                         formatter: function (val, { seriesIndex, dataPointIndex, w }) {
                          return pruebaFuncion(seriesIndex, dataPointIndex);
                          return auxSeries[2].data[dataPointIndex]
                            return val + " - " + seriesIndex + " - " + dataPointIndex + " - " + w
                        },
                      },
                      xaxis: {
                        categories: daylistParse,
                      },
                      yaxis:{
                        min: minYaxis,
                      },
                      legend: {
                        position: 'right',
                      },
                      animations: {
                        enabled: false,
                      } ,
                      colors: this.coloresGrafica,
                      fill: {
                        opacity: [0.55, 0.55],
                        gradient: {
                          inverseColors: false,
                          shade: 'light',
                          type: "vertical",
                          opacityFrom: 0.85,
                          opacityTo: 0.55,
                          stops: [0, 100, 100, 100]
                        }
                      },
                      tooltip: {
                        enabled: true,
                        shared: true,
                        intersect: false,
                        y: {
                          formatter: function (y, { series, seriesIndex, dataPointIndex, w }) {

                            if (auxSeries[seriesIndex].name.includes("Visitas") && auxVentasCheck && typeof y !== "undefined") {
                              return y * 10;
                            }
                            if (auxSeries[seriesIndex].name.includes("Stock") && typeof y !== "undefined") {
                              return getVentaDiaSku(y, seriesIndex, dataPointIndex);
                            }

                            return y;

                          }
                        }
                      }
                    };

                    console.log(auxVentasSku);

                    function getVentaDiaSku(stock, indexSku, indexDay)
                    {
                      return stock + " | " + auxVentasSku[indexSku-2].data[indexDay];
                    }


              setTimeout(()=>{
                this.chartOptions = auxChart;
                this.series = auxSeries;
              }, 100);

              this.dayListArray = daylist;
              this.cargarColumnas(daylist);

              this.variantesStockSeleccionado = auxVarianteStock;
              this.ventasSkuSeleccionado = auxVentasSku;
              this.cargarDatosTabla();
              

              //console.log(this.dayListArray);
            }
          },20);

         
        }
      },
      cargarColumnas(daylist)
      {
        this.columnasTable = [];
        this.columnasTable.push( 
          {
            key: "sku",
            label: "SKU",
            sortable: true,
            stickyColumn: true,
            thStyle: { width: "15%" },
          });
        
        let auxIndex = 0;

        daylist.forEach(day => {
          //let text = day.split('-')[1] + "-" + day.split('-')[2];
          
          let text = day.split('-')[2];
           this.columnasTable.push( 
            {
              key: day,
              label: text,
              sortable: false,
            });

            auxIndex++;
          
        });

        //console.log(this.columnasTable);
      },
      cargarDatosTabla(){
        this.linesTable = [];

        if(this.propiedadTablaSelect == "Stock")
        {        
          this.variantesStockSeleccionado.forEach(stock => {

            let newLine = {sku: stock.sku};

            this.dayListArray.forEach((day, index) => {
              newLine[day] = stock.data[index];
            });
            
            this.linesTable.push(newLine);
          });
        }
        else {
           this.ventasSkuSeleccionado.forEach(venta => {

            let newLine = {sku: venta.sku};

            this.dayListArray.forEach((day, index) => {
              newLine[day] = venta.data[index];
            });
            
            this.linesTable.push(newLine);
          });
        }

        //console.log(this.linesTable);

      },
      deseleccionarSeries()
      {
        

        this.series.forEach(data => {          
          if(data.name.includes("Stock"))  
            this.$refs.marketingGrafica.hideSeries(data.name);
        });

        console.log(this.series);

        //this.$refs.marketingGrafica.hideSeries("Ventas: Leather Desk Mat");
      },
      getAnotationsGrafica(stocks, daylist)
      {
          /*console.log(daylist);
          console.log(stocks);*/
        if(this.articulos.length > 1)
          return [];

        let auxAnotations = [];

        for (let y = 0; y < daylist.length; y++) {

          let anyStock = false;
          let noStock = false;

          for (let x = 0; x < stocks.length; x++) {
            if(stocks[x].data[y] <= 0)
              noStock = true;
            else
              anyStock = true;
          }


          let colorStock = "";
          let textStock = "";

          if(noStock && !anyStock)
          {
            colorStock = "#FF9078";
            textStock = "No Stock";
          }
          else if(noStock && anyStock)
          {
            colorStock = "#FFB600";
            textStock = "Parcial Stock";
          }

          if(noStock)
          {
             auxAnotations.push({
                index: y,
                fillColor: colorStock,
                text: textStock,
              });
          }

        }


        let res = [];

        if(auxAnotations.length == 0)
          return [];

        let startIndex = auxAnotations[0].index;
        let lastIndex = startIndex;
        let startFillColor = auxAnotations[0].fillColor;
        let startText = auxAnotations[0].text;
        let cantidadRango = 1;

        for (let y = 1; y < auxAnotations.length; y++) {

          if(auxAnotations[y].index - lastIndex > 1 || startText != auxAnotations[y].text)//Si no es 1 es que no es correlativo
          {
            if(cantidadRango > 1)
            {
              res.push({
                  x: daylist[startIndex],
                  x2: daylist[lastIndex],
                  index: y,
                  fillColor: startFillColor,
                  opacity: 0.4,
                  label: {
                    borderColor: startFillColor,
                    style: {
                      fontSize: '10px',
                      color: '#fff',
                      background: startFillColor,
                    },
                    offsetY: -10,
                    text: startText,
                  }
                });
            }
            else
            {
              res.push({
                  x: daylist[startIndex],
                  index: y,
                  fillColor: startFillColor,
                  opacity: 0.4,
                  label: {
                    borderColor: startFillColor,
                    style: {
                      fontSize: '10px',
                      color: '#fff',
                      background: startFillColor,
                    },
                    offsetY: -10,
                    text: startText,
                  }
                });
            }

            cantidadRango = 1;

            startIndex = auxAnotations[y].index;
            startFillColor = auxAnotations[y].fillColor;
            startText = auxAnotations[y].text;
            lastIndex = startIndex;
          }
          else
          {
            cantidadRango++;
            lastIndex = auxAnotations[y].index;
          }
         
        }

         if(cantidadRango > 1)
            {
              /*console.log(lastIndex);
              console.log(auxAnotations);*/
              res.push({
                  x: daylist[startIndex],
                  x2: daylist[lastIndex],
                  fillColor: startFillColor,
                  opacity: 0.4,
                  label: {
                    borderColor: startFillColor,
                    style: {
                      fontSize: '10px',
                      color: '#fff',
                      background: startFillColor,
                    },
                    offsetY: -10,
                    text: startText,
                  }
                });
            }
            else
            {
              res.push({
                  x: daylist[startIndex],
                  fillColor: startFillColor,
                  opacity: 0.4,
                  label: {
                    borderColor: startFillColor,
                    style: {
                      fontSize: '10px',
                      color: '#fff',
                      background: startFillColor,
                    },
                    offsetY: -10,
                    text: startText,
                  }
                });
            }



        /* auxAnotations.push({
                x: daylist[y],
                index: y,
                fillColor: colorStock,
                opacity: 0.4,
                label: {
                  borderColor: colorStock,
                  style: {
                    fontSize: '10px',
                    color: '#fff',
                    background: colorStock,
                  },
                  offsetY: -10,
                  text: textStock,
                }
              }); */


        

          /*let res = [{
                x: daylist[4],
                x2: daylist[6],
                fillColor: '#FC5B38',
                opacity: 0.4,
                label: {
                  borderColor: '#FC5B38',
                  style: {
                    fontSize: '10px',
                    color: '#fff',
                    background: '#FF9078',
                  },
                  offsetY: -10,
                  text: 'No Stock',
                }
              }];*/
            /*{
                x: new Date('26 Nov 2017').getTime(),
                x2: new Date('28 Nov 2017').getTime(),
                fillColor: '#B3F7CA',
                opacity: 0.4,
                label: {
                  borderColor: '#B3F7CA',
                  style: {
                    fontSize: '10px',
                    color: '#fff',
                    background: '#00E396',
                  },
                  offsetY: -10,
                  text: 'X-axis range',
                }
              }*/
        return res;
      },
      moreSlider()
      {
        //console.log(this.sliderFecha);
        this.sliderFecha.push(this.dayListParseSlider[this.dayListParseSlider.length-1]);

      },
      lessSlider()
      {
        this.sliderFecha.pop();
      }
    },
    watch: {
      items(){
        this.articulos = this.items;

        if(this.rangeDate != null && this.rangeDate.includes("to"))
          this.getDatosFecha();     
        else
          this.calcularDatos();
        //console.log(this.items);
      },
      anyo(){
        this.calcularDatos();
      },
      propiedadGraficaSelect(){
        if(this.rangeDate != null && this.rangeDate.includes("to"))
          this.getDatosFecha();
        else
          this.calcularDatos();
      },
      rangeDate()
      {
        //this.getDatosFecha();     
        if(this.rangeDate != null && this.rangeDate.includes("to"))
          this.getDatosFecha();
        else
          this.calcularDatos();
      },
      visitasCheck(){
        if(this.rangeDate != null && this.rangeDate.includes("to"))
          this.getDatosFecha();
        else
          this.calcularDatos();
      },
      stockCheck()
      {
        if(this.rangeDate != null && this.rangeDate.includes("to"))
          this.getDatosFecha();
        else
          this.calcularDatos();
      },
      ventasCheck()
      {
        if(this.rangeDate != null && this.rangeDate.includes("to"))
          this.getDatosFecha();
        else
          this.calcularDatos();
      },
      propiedadTablaSelect(){
        this.cargarDatosTabla();
      }
    }
  }
  
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-slider.scss';
</style>